import { createSlice } from "@reduxjs/toolkit";
import { addRole, editRole, getPermisionList, getRole, getRoleList } from "../services/role-service";

const initialState = {
  roles: [],
  role: null,
  pagination: null,
  error: [],
  permissions:[],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const roleSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRoleList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRoleList.fulfilled, (state, action) => {
        state.roles = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getRoleList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getRole.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRole.fulfilled, (state, action) => {
        state.roles = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getRole.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addRole.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(addRole.fulfilled, (state, action) => {
        state.roles = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addRole.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editRole.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(editRole.fulfilled, (state, action) => {
        state.roles = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editRole.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(getPermisionList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPermisionList.fulfilled, (state, action) => {
        state.permissions = action.payload.data.items;
        state.successMessage = null;
        state.loading = false;
        state.success = false;
      })
      .addCase(getPermisionList.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
  },
});
export const { resetSuccess, resetState, resetError } = roleSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default roleSlice.reducer;
